import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const SettingsRoutes = defineRoute({
    firebase: {
        route: {
            path: "/settings-firebase",
            component: () => loadView(import("./SettingsFirebaseHome.vue")),
        },
    },
});
